import { share } from 'rxjs/operators';
import { computeIsElementEmpty } from '../../helpers/elementHtmlEditor/empty';
import { fromMutationObserver } from '../../helpers/fromMutationObserver';
import { ServiceLike } from '../base/service';
import { EmptyService } from '../text/emptyService';
import { ElementService } from './elementService';

export function createElementEmptyService(element: Element, ...dependencies: ServiceLike[]): EmptyService {
  return new ElementEmptyService(element, ...dependencies);
}

const ONLY_WHITESPACE_REGEXP = /^[ \t\n\r\f\u00a0]*$/g;

export function isOnlyWhitespace(text: string): boolean {
  return Boolean(text.match(ONLY_WHITESPACE_REGEXP));
}

// This is separate from ElementHtmlService, because the behavior around compositions is different.
export class ElementEmptyService extends ElementService<Element> implements EmptyService {
  constructor(element: Element, ...dependencies: ServiceLike[]) {
    super(element, ...dependencies, {
      changes$: fromMutationObserver(element, {
        characterData: true,
        childList: true,
        subtree: true,
      }).pipe(share()),
    });
  }

  get isEmpty() {
    // TODO: Profile this.
    return computeIsElementEmpty(this.document, this.element);
  }
}
